import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, ClipboardList, Users, User } from 'lucide-react';

export const hrNavInternal = (isHovered, styles) => (
     <>
          <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <Home size={20} />
               {isHovered && <span> Dashboard</span>}
          </NavLink>
          {/* <NavLink to="/profile" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                                   <User size={20} />
                                   {isHovered && <span> Profile</span>}
                              </NavLink> */}
          <NavLink to="/attendance" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <CalendarCheck size={20} />
               {isHovered && <span> Attendance</span>}
          </NavLink>

          <NavLink to="/employee-master" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <Users size={20} />
               {isHovered && <span > Employees</span>}
          </NavLink>
     </>
);